export default class Beleg {
    /** PK: Beleg | erforderlich */
    public beleg_id: number | null = null;
    /** FK: Impfstelle | erforderlich */
    public impfstelle_id: number | null = null;
    /** Erstelltes Jahr | erforderlich */
    public jahr: number | null = null;
    /** Laufende Belegnummer | erforderlich */
    public belegnr: number | null = null;
    /** FK: Patient | erforderlich */
    public patnr: number | any = null;
    /** Rechnungsempfänger | max. 255 Zeichen */
    public name: string | null = null;
    /** Adresszeile 1 | max. 100 Zeichen */
    public adresszeile1: string | null = null;
    /** Adresszeile 2 | max. 100 Zeichen */
    public adresszeile2: string | null = null;
    /** Adresszeile 3 | max. 100 Zeichen */
    public adresszeile3: string | null = null;
    /** Adresszeile 4 | max. 100 Zeichen */
    public adresszeile4: string | null = null;
    /** Rechnungsdatum | erforderlich */
    public datum: string | null = null;
    /** Gesamtbetrag der Rechnung in Brutto | erforderlich */
    public gesamtbetrag: number | any = null;
    /** Umsatzsteuer */
    public ust: number | null = null;
    /** FK: Zahlungsart | max. 20 Zeichen */
    public zahlungsart: string | null = null;
    /** Rechnung Gedruckt-Status | max. 1 Zeichen | erforderlich */
    public gedruckt: string | null = null;
    /** Rechnung Storniert-Status | max. 1 Zeichen | erforderlich */
    public storniert: string | null = null;
    /** FK: Kassaabschluss */
    public abschlussnr: number | null = null;
    /** Anmerkung | max. 100 Zeichen */
    public anmerkung: string | null = null;
    /** Offener Rechnungsbetrag des Patienten */
    public restbetrag: number | null = null;
    /** Datum der Zahlungseingang vom Zahlungsschein */
    public zahlungseingang: string | null = null;
    /** Geplante Impfungen und Untersuchungen | max. 1073741823 Zeichen */
    public geplantes: string | null = null;
    /** Diagnosetext | max. 255 Zeichen */
    public diagnose: string | null = null;
    /** Rechnung nachträglich geändert j/n (z.B. Adresse) | max. 1 Zeichen */
    public berichtigt: string | null = null;
    /**  */
    public gemahnt: string | null = null;
    /**  */
    public zahlungsziel: string | null = null;
    public steuersatz: number | null = null;

    public zahlungsart_rechnungstext: string | null = null;
    public impfstelle_bezeichnung: string | null = null;
    public impfstelle_adresszeile1: string | null = null;
    public impfstelle_adresszeile2: string | null = null;
    public impfstelle_adresszeile3: string | null = null;
    public impfstelle_adresszeile4: string | null = null;
    public patient_geschlecht: string | null = null;
    public patient_strasse: string | null = null;
    public patient_ort: string | null = null;
    public patient_plz: string | null = null;
    public patient_titel: string | null = null;
    public patient_titel_nach_name: string | null = null;
    public patient_vorname: string | null = null;
    public patient_nachname: string | null = null;
    public zusatztext: string | null = null;

    public get isStorniert(): boolean {
        return this.storniert === 'j';
    }

    public get belegempfaenger(): string {
        const adresszeile = this.adresszeile1?.trim() ?? '';
        return adresszeile !== '' ? adresszeile : this.name?.trim() ?? '';
    }

    constructor(data?: Partial<Beleg>) {
        Object.assign(this, data);
    }
}
